export default "__VITE_ASSET__fea4484e__"